
import { contentService } from "@/helpers/api-services/content.service";
import { authComputed } from "@/state/helpers";
import { KcmContent } from "@/types";

export default {
  props: {
    content: {
      required: true,
      type: Object as () => KcmContent,
    },
  },

  methods: {
    contentHasCategory: contentService.contentHasCategory,

    // Uses the method above to determine the syling of the card, image on top or bottom.
    stylingCheck(content: KcmContent): boolean {
      return (
        content.content_type === "blog" &&
        (this.contentHasCategory(content, "infographics") ||
          this.contentHasCategory(content, "holidays"))
      );
    },

    getDate: contentService.getDate,

    getDateLink: contentService.getDateLink,

    getDaySuffix: contentService.getDaySuffix,

    generateLink: contentService.generateLink,

    generateVideoLink: contentService.generateVideoLink,

    getInfographic(contents: string): string {
      const parsedContents = new DOMParser().parseFromString(
        contents,
        "text/html"
      );
      const infographic = parsedContents.querySelector("img");
      if (infographic) {
        return infographic.src;
      }
      return "";
    },

    determineLink(content: KcmContent): string {
      if (content.content_type === "videos") {
        return this.generateVideoLink(content);
      } else {
        return this.generateLink(content);
      }
    },
  },

  computed: {
    ...authComputed,
  },
};
